import { defineComponent as _defineComponent } from 'vue'
import { mdiDelete, mdiInboxOutline, mdiPlus } from "@mdi/js";
import { DraggablePopup } from "@hungpv97/vue-library-draggable";
import ModuleContainer from "@components/Map/ModuleContainer.vue";
import MapControlButton from "@components/Map/control/MapControlButton.vue";
import { useMap } from "@components/Map/mixins/useMap";
import SvgIcon from "@jamescoyle/vue-icon";
import enLang from "@/lang/en/crs-control.json";
import { useShow } from "@/hooks/useShow";
import { updateMapLang } from "@/store/store-lang";
import Collapse from "@/components/Collapse/index.vue";
import { computed } from "vue";
import InputText from "@/components/input/input-text.vue";
import InputSelect from "@/components/input/input-select.vue";
import { getCrsItems, setCrsItems, CrsItem } from "@/store/store-crs";

export default /*#__PURE__*/_defineComponent({
  __name: 'CrsControl',
  setup(__props) {

const { $map, c_mapId } = useMap();
const [show, setShow] = useShow(false);
updateMapLang(c_mapId.value, {
  map: { "crs-control": enLang }
});
function onToggleShow() {
  setShow(!show.value);
}
const crs_items = computed(() => {
  return getCrsItems(c_mapId.value);
});
const unit_items = [
  { text: "degree", value: "degree" },
  { text: "meter", value: "meter" }
];
const path = {
  delete: mdiDelete,
  plus: mdiPlus
};
const onRemove = (item: CrsItem) => {
  setCrsItems(
    c_mapId.value,
    crs_items.value.filter((x) => x.epsg !== item.epsg)
  );
};
const onAdd = () => {
  crs_items.value.push({ name: "", unit: "degree", epsg: "" });
};

return { __sfc: true,$map, c_mapId, show, setShow, onToggleShow, crs_items, unit_items, path, onRemove, onAdd, mdiInboxOutline, DraggablePopup, ModuleContainer, MapControlButton, SvgIcon, Collapse, InputText, InputSelect }
}

})